import { Skeleton, Stack } from "@chakra-ui/react";

interface SkeletonListProps {
  height: number;
  items: number;
}

export const SkeletonList = ({ height, items }: SkeletonListProps) => {
  return (
    <Stack>
      {Array.from(Array(items).keys()).map((i) => (
        <Skeleton key={i} height={height} />
      ))}
    </Stack>
  );
};
